import React from 'react';
import './home.scss';
import Header from '../header/header';
import Info from '../info/info';
import Timeline from '../timeline/timeline';
import ProgressBar from '../progress-bar/progress-bar';
import Card from '../card/card';
import Footer from '../footer/footer';
import About from '../intro/About';
import Chat from '../chat/Chat';

export class Home extends React.Component<any> {
  constructor(props:any) {
    super(props)
    this.state = { showTooltip: false, showChat: false }
    // console.log(props)
  }

  render(): React.ReactNode {
    const homeData: any = this.props.profileData || {};
    const educationTimeLine: any = {
      title: 'Education',
      timeLineData: homeData.educationList
    };
    const workExperianceTimeLine: any = {
      title: 'Work EXPERIANCE',
      timeLineData: homeData.workExpList
    };

    return (
      <div className="home">
        <Header key={'x'} header={homeData.headerList} isSuperAdmin={homeData.isSuperAdmin}></Header>
        <Info key={'y'} infoData={homeData}></Info>
        <div className="container">
          <div className="home__description" id="resumes">
            <div className="home__description-title">Hi</div>
            <About text={homeData?.myInfo} />
            {homeData?.resumeLink && (
              <a href={homeData.resumeLink} target="_blank" rel="noopener noreferrer" className="home__cv-btn">
                <i className="fas fa-download"></i> DOWNLOAD CV
              </a>
            )}
          </div>
        </div>
       { homeData.educationList &&
        <Timeline key={'p'} data={educationTimeLine}></Timeline>}
       { homeData.workExpList &&
        <Timeline key={'w'} data={workExperianceTimeLine}></Timeline>}
        <div className="container">
          <div className="home__heading">
            Technical skills
          </div>
          {
            homeData.technicalSkillsList?.map((skill: any, i: number) => {
              return (
                <div key={i}>
                  <div className="home__sub--heading">
                    {skill.skillType}
                  </div>
                  <div className="home__wrapper">
                    {
                      (skill.skillsList || []).map((item: any, index: number) => {
                        return (
                          <ProgressBar key={index + i} name={item.name} rating={item.rating}></ProgressBar>
                        )
                      })

                    }
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className="home__projects container" key={'r'}>
          <div className="home__heading">
            My Projects
          </div>
          <div className="home__projects--list">
            {
              homeData.projectList?.map((project:any, index: number) => {
                return (
                  <Card cardData={project} key={index}></Card>
                )
              })
            }
          </div>
        </div>
        <div id="contacts">
        <Footer footerData={homeData}></Footer>
        </div>
        {homeData.isChat && (
          <div className="home__chat-icon" onMouseEnter={() => this.setState({showTooltip: true})} onMouseLeave={() => this.setState({showTooltip: false})} onClick={() => this.setState({showChat: true})}>
            <i className="fas fa-comments"></i>
            {this.state?.showTooltip && (
              <div className="home__chat-tooltip">
                <div className="home__chat-tooltip-title">Ved Prakash AI Agent</div>
                <div className="home__chat-tooltip-text">Ask anything about me with AI powered</div>
              </div>
            )}
          </div>
        )}
        {this.state.showChat && (
          <div className="home__chat-popover">
            <div className="home__chat-panel">
              <div className="home__chat-panel-header">
                <div>
                  <div className="home__chat-panel-title">Ved Prakash AI Agent</div>
                  <div className="home__chat-panel-subtitle">Ask anything about me</div>
                </div>
                <div className="home__chat-panel-actions">
                  <button className="home__chat-panel-expand" onClick={() => window.open('/chat', '_blank')} title="Open in new tab">
                    <i className="fas fa-external-link-alt"></i>
                  </button>
                  <button className="home__chat-panel-close" onClick={() => this.setState({showChat: false})}>&times;</button>
                </div>
              </div>
              <Chat compact />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Home;